<!-- 选择物品 -->
<template>
  <el-form-item :label="label">
    <yx-commodity-selector @select="select" ref="child" @clear="reset" width="222px"/>
  </el-form-item>
</template>

<script>
import { inject, ref } from 'vue';

export default {
  kind: 'yq-物品选择',
  props: {
    // 初始值.
    value: {
      type: [Array, String, Number, Object],
      default: () => ({}),
    },
    label: {
      type: String,
      default: '物品：',
    },
  },
  setup(props) {
    const child = ref(null);
    const useQuery = inject('useQuery');

    function reset() {
      child.value.clearField();
      // eslint-disable-next-line no-use-before-define
      clazz.value = {};
    }
    const clazz = useQuery('commodity', props.value, reset);

    function select(obj) {
      clazz.value = obj;
    }

    return {
      select,
      child,
      reset,
    };
  },
};
</script>
